import { breadcrumb } from './breadcrumb';

export const notify = {
  breadcrumb,

  notification: {
    field: {
      type: 'Тип',
      text: 'Текст',
      created_at: 'Дата'
    },

    senders_update: {
      body: 'Статус отправителя {name} изменился на {status}.',
      success_amount:
        'Имя отправителя {name} одобрено. С вас будет ежемесячно списываться {amount}.',
      success: 'Имя отправителя {name} одобрено.',
      error: 'Имя отправителя {name} отклонено.',
      on_deactivation: 'Отправитель {name} будет деактивирован в течение 1-3 дней.',
      text_link: 'Перейти в раздел'
    },

    mailings_update: {
      moderation_success: 'СМС рассылка {name} одобрена. Отправка произойдет {start_at}.',
      moderate_too_late:
        'СМС рассылка {name} не была одобрена до запланированного времени отправки. Рассылка отклонена.',
      pending: 'СМС рассылка {name} одобрена.',
      rejected: 'СМС Рассылка {name} отклонена.',
      failed: 'СМС Рассылка {name} не удалась.',
    },

    rates_update: {
      body:
        'Ваш тариф на услуги {type} был обновлен. Пожалуйста, посмотрите подробную информацию на странице "{link}".',

      type: {
        messaging: 'смс',
        voice: 'голосовой связи',
        hlr: 'HLR',
        default: 'связи',
        number_verification: 'верификации'
      },

      link: {
        label: 'Тарифы'
      }
    },

    low_balance: {
      body:
        'На вашем аккаунте недостаточно средств. Пожалуйста, пополните ваш баланс, чтобы продолжить пользоваться сервисами ZORRA.'
    },

    not_enough_money: {
      body: 'На балансе недостаточно средств для HLR проверки файла'
    },

    documents_update: {
      body: {
        approved: 'Загруженный документ подтвержден.',
        rejected:
          'Загруженный документ был отклонен. Для получения подробностей обратитесь в службу поддержки.'
      }
    },

    export_complete: {
      body: 'Ваш файл экспорта готов.',
      link: 'Скачать'
    },

    recording_export_complete: {
      body: 'Ваш файл экспорта готов.',
      link: 'Скачать'
    },

    empty_records: {
      body: 'Нет записей разговоров за выбранный период'
    },

    button: {
      see_all: 'Смотреть все'
    },

    export_type: {
      mailing_export_complete: 'SMS',
      senders_update: 'Отправители',
      mailings_update: 'Рассылки',
      voice_export_complete: 'Звонки',
      database_export_complete: 'БД',
      pbx_export_complete: 'АТС',
      recording_export_complete: 'АТС записи',
      stat_export_complete: 'Автоинформатор',
      documents_update: 'Профиль',
      rates_update: 'Обновление тарифа',
      low_balance: 'Низкий баланс',
      custom: 'Уведомление',
      not_enough_money: 'Недостаточно средств',
      predictive_export_stats_complete : "Предиктив"
    }
  }
};
